module.exports = {
    /*
     * @param arr - Array of vehicles
     * @param attrs - Array of property attributes to sort on, recursive
     * Will allow fallback to single string value
     */
    sortArray: function (arr, attrs) {
        const module = this;


        if (!attrs || !attrs.length) return arr;

        let sortAttrs = attrs;
        if (!Array.isArray(attrs)) sortAttrs = [attrs];

        sortAttrs.forEach(function (sortAttribute) {
            let sortProperty = module.snakeToCamel(sortAttribute);
            if (sortProperty === 'prediction') sortProperty = 'predictionMinutesAway';
            
            if (sortProperty === 'shortRoute') {
                let numbersOnly = /[0-9]+/;
                let lettersOnly = /[A-Za-z]+/;

                let hasLetters = module.shortRoutesHaveLetters(arr);
                if (!hasLetters) {
                    arr.sort((a, b) => {
                        if (a[0].shortRoute !== b[0].shortRoute) {
                            // Treate the shortRoutes as integers
                            return parseInt(a[0].shortRoute) - parseInt(b[0].shortRoute);
                        } else {
                            // If the shortRoutes are the same, sort by other property
                            return module.sortByOtherProperty(a, b);
                        }
                    });
                } else {
                    arr.sort((a, b) => {
                        let aCharAtZero = a[0].shortRoute.charAt(0);
                        let bCharAtZero = b[0].shortRoute.charAt(0);

                        // Get the numbers portion of the shortRoutes.
                        // exec returns an array.
                        let aNumbers = numbersOnly.exec(a[0].shortRoute);
                        let bNumbers = numbersOnly.exec(b[0].shortRoute);

                        // Get the letters portion of the shortRoutes
                        // exec returns an array.
                        let aLetters = lettersOnly.exec(a[0].shortRoute);
                        let bLetters = lettersOnly.exec(b[0].shortRoute);

                        let bothRoutesStartWithNumbers = numbersOnly.test(aCharAtZero) && numbersOnly.test(bCharAtZero);
                        let oneRouteStartsWithNumbers = numbersOnly.test(aCharAtZero) || numbersOnly.test(bCharAtZero);

                        if (bothRoutesStartWithNumbers) {
                            // If the numbers are the same:
                            if (aNumbers[0] === bNumbers[0]) {
                                // If no letters in the shortRoutes at all OR even the letters are the same, use other properties to sort.
                                // Eg. 44 vs 44 OR 44X vs 44X
                                if ((aLetters === null && bLetters === null) || (aLetters !== null && bLetters !== null && aLetters[0] === bLetters[0])) {
                                    return module.sortByOtherProperty(a, b);
                                } else {
                                    // Let the numbers-only route go first.
                                    // Eg., 44 vs 44X -> 44 should go first
                                    return aLetters === null ? -1 : 1;
                                }
                            } else {
                                // Treat the short routes as integers
                                return parseInt(aNumbers[0]) - parseInt(bNumbers[0]);
                            }
                        } else if (oneRouteStartsWithNumbers) {
                            // Let the numbers-only shortRoute go first
                            // Eg., 44 vs 44X -> 44 should go first
                            return numbersOnly.test(aCharAtZero) ? -1 : 1;
                        } else {
                            // Both routes start with letters
                            if (aLetters[0] === bLetters[0]) {
                                return module.sortByOtherProperty(a, b);
                            } else {
                                return aLetters[0].localeCompare(bLetters[0]);
                            }
                        }
                    });
                }
            } else {
                // JS sort is mutable
                arr.sort(function (a, b) {
                    // Compare requested attr of first item in array
                    if (a[0][sortProperty] > b[0][sortProperty]) {
                        return 1;
                    }
                    if (a[0][sortProperty] < b[0][sortProperty]) {
                        return -1;
                    }
                    // a must be equal to b
                    return 0;
                });
            }
        })
        return arr;
    },

    snakeToCamel: function (str) {
        return str.toLowerCase().replace(/([-_][a-z])/g, group =>
            group
                .toUpperCase()
                .replace('-', '')
                .replace('_', '')
        );
    },

    /*
     * @param collection - Object of props (usually vehicles/items)
     * @param rowLimit - Integer to reduce collection props to
     */
    limitObjectArray: function (collection, rowLimit) {
        if (rowLimit && rowLimit <= 0) {
            var newRows = {};
            for (var k in collection) {
                // Recreate row object by counting down with rowlimit
                // This is because Object.keys not supported
                if (rowLimit !== 0) {
                    newRows[k] = collection[k];
                    rowLimit--;
                }
            }
            return newRows;
        } else {
            return collection;
        }
    },

    shortRoutesHaveLetters: function (arr) {
        // Numbers-only shortRoutes will return false. Anything with letters will return true.
        let withLetters = arr.map((a) => isNaN(a[0].shortRoute));
        let hasLetters = withLetters.some((withLetter) => withLetter);

        return hasLetters;
    },

    sortByOtherProperty: function (a, b) {
        // This array is in order of preference as set by the TS Admin API.
        const properties = ['destination', 'fullRoute'];
        let aProperty = null;
        let bProperty = null;
        // Usually, prediction objects from the same agency will contain the same properties.
        // For example, they will always contain destinations or full route names (if the
        // route is a loop). But in case they don't all have destinations, then let them
        // use the full route name as a fallback.
        for (const property of properties) {
            if (property in a[0] && aProperty === null) {
                aProperty = property;
            }
            if (property in b[0] && bProperty == null) {
                bProperty = property;
            }
        }

        return a[0][aProperty].localeCompare(b[0][bProperty]);
    }

}
